module.exports = "pegasus_template/assets/blocks/tile-layout-16.png";